import { EnvFlags, UserFlags } from 'ha/constants/FeatureFlags';

import { Actions } from '../constants';

export default (
  features: { [K in EnvFlags | UserFlags]?: boolean | 'on' | 'off' },
) => ({
  type: Actions.SET_FEATURES,
  payload: features,
});
